import { localStorageHelper } from "../hooks/localStorageHelper";
import { GroupAdmin, PROFILE_KEY, Roles } from "./Constants";

export const getYearDiffWithMonth = (startDate: Date, endDate: Date) => {
  const ms = endDate.getTime() - startDate.getTime();

  const date = new Date(ms);
  return Math.abs(date.getUTCFullYear() - 1970);
};

const getRolesFromToken = (): string[] =>
  localStorageHelper.load(PROFILE_KEY)?.roles ?? [];

const getGroupsFromToken = (): string[] =>
  localStorageHelper.load(PROFILE_KEY)?.groups ?? [];

export const hasRole = (roleName: Roles): boolean => {
    const roles = getRolesFromToken();
  return roles.includes(roleName);
};

/**
 * Returns true if the user has any of the roles passed in the array
 * @param roleNames - list of roles to check
 * @returns
 */
export const hasAnyRole = (roleNames: Roles[]): boolean => {
  const roles = getRolesFromToken();
  return roleNames.some((role) => roles.includes(role));
};

export const hasGroupAdminRole = (roleName: GroupAdmin): boolean => {
  return getGroupsFromToken().includes(roleName);
};

export const hasAnyGroupAdminRole = (roleNames: GroupAdmin[]): boolean => {
  const groups = getGroupsFromToken();
  return roleNames.some((role) => groups.includes(role));
};
